var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tt-city-select",on:{"click":_vm.openCityModal}},[_vm._m(0),_c('div',{staticClass:"tt-city-select__name ff-mont tt-city-select__active"},[_vm._v(" "+_vm._s(_vm.currentCity ? _vm.currentCity.name : 'Выберите город')+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-icon"},[_c('img',{attrs:{"src":require("@/assets/icons-new/geo.svg")}})])
}]

export { render, staticRenderFns }